export default "__VITE_ASSET__k0ZV4fay__"